var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEyeAltLined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.72069 10.622C5.63493 4.30782 14.3651 4.30782 17.2793 10.622C17.3819 10.8443 17.6452 10.9413 17.8674 10.8387C18.0897 10.7361 18.1867 10.4728 18.0841 10.2506C14.853 3.24981 5.14702 3.24981 1.9159 10.2506C1.81333 10.4728 1.91034 10.7361 2.13257 10.8387C2.35481 10.9413 2.61812 10.8443 2.72069 10.622ZM11.6053 11.9727C11.6053 11.0861 10.8866 10.3674 10.0001 10.3674C9.11349 10.3674 8.39479 11.0861 8.39479 11.9727C8.39479 12.8592 9.11349 13.5779 10.0001 13.5779C10.8866 13.5779 11.6053 12.8592 11.6053 11.9727ZM10.0001 9.48102C11.3762 9.48102 12.4917 10.5966 12.4917 11.9727C12.4917 13.3488 11.3762 14.4643 10.0001 14.4643C8.62396 14.4643 7.50841 13.3488 7.50841 11.9727C7.50841 10.5966 8.62396 9.48102 10.0001 9.48102Z",
    fill: "#0C0C0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEyeAltLined);
export default __webpack_public_path__ + "static/media/ic_eye_alt_lined.65efebd9d4681b3b2930c368b674afba.svg";
export { ForwardRef as ReactComponent };